import React, { memo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import ICONS from './icons.js';

import './SvgIcon.scss';

const SvgIcon = ({ className, icon, responsive, ...rest }) => {
  if (!icon) return null;
  const Icon = ICONS[icon] || ICONS[icon.toLowerCase()];
  if (!Icon) return null;

  return (
    <Icon
      className={cx(`svg-icon svg-icon--${icon}`, className, {
        'svg-icon--responsive': responsive,
      })}
      {...rest}
    />
  );
};

SvgIcon.defaultProps = {
  className: '',
  responsive: false,
};

SvgIcon.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string.isRequired,
  responsive: PropTypes.bool,
};

export default memo(SvgIcon);
